import React from 'react'
import PageHeader from '@/components/Common/PageHeader'
import SEOHead from '@/components/SEO/SEOHead'
import { buildGraph, breadcrumbListData, webPageSchema } from '@/data/structured-data'

const PrivacyPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Gizlilik Politikası | Ardıç Veteriner Kliniği"
        description="Ardıç Veteriner Kliniği gizlilik politikası: hangi kişisel verileri hangi amaçla işliyoruz, ne kadar süre saklıyoruz ve haklarınızı nasıl kullanabilirsiniz."
        canonicalUrl="/privacy"
        structuredData={buildGraph(
          webPageSchema({ name: 'Gizlilik Politikası', description: 'Ardıç Veteriner Kliniği kişisel verilerin korunması ve gizlilik ilkeleri.', url: '/privacy' }),
          breadcrumbListData([
            { name: 'Ana Sayfa', url: '/' },
            { name: 'Gizlilik Politikası', url: '/privacy' }
          ])
        )}
      />
      <PageHeader title="Gizlilik Politikası" subtitle="Kişisel verilerin korunması ve gizlilik ilkemiz." />
      <section className="section-padding">
        <div className="container-custom">
          <div className="bg-white border rounded-xl p-8 text-gray-700 space-y-4">
            <p>Ardıç Veteriner Kliniği olarak, kullanıcılarımızın gizliliğini önemsiyoruz. Bu politika, topladığımız verileri ve kullanım amaçlarımızı açıklar.</p>
            <h2 className="text-lg font-bold">Toplanan Veriler</h2>
            <ul className="list-disc list-inside">
              <li>İletişim bilgileri (telefon, e-posta)</li>
              <li>Randevu taleplerinde paylaşılan bilgiler</li>
              <li>Site kullanımına ilişkin anonim analitik veriler</li>
            </ul>
            <h2 className="text-lg font-bold">İletişim</h2>
            <p>Gizlilikle ilgili sorularınız için bize e-posta ile ulaşabilirsiniz.</p>
          </div>
        </div>
      </section>
    </>
  )
}

export default PrivacyPage


